module.exports = __webpack_public_path__ + "img/1.75718a40.png";